<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr class="nevs-table-filters">
                    <td>
                        <NevsTextField v-model="tableData.filters.first_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.last_name"></NevsTextField>
                    </td>
                    <td>
                        <NevsTextField v-model="tableData.filters.oib"></NevsTextField>
                    </td>
                    <td>
                        <NevsSelect v-model="tableData.filters.active"
                                    :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
                    </td>
                    <td></td>
                </tr>
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell help-edit" @click="openClick(item.id)">{{ item.first_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.last_name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.oib }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.active_display }}</td>
                    <td class="nevs-table-actions">
                        <span :title="$LANG.Get('tooltips.openInNewWindow')" class="nevs-table-button help-edit-new"
                            @click="openClick(item.id, true)"><i class="fa-solid fa-up-right-from-square"></i></span>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";

export default {
    name: "ModulePersons",
    components: {NevsSelect, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'first_name',
                        label: this.$LANG.Get('fields.firstName')
                    },
                    {
                        name: 'last_name',
                        label: this.$LANG.Get('fields.lastName')
                    },
                    {
                        name: 'oib',
                        label: this.$LANG.Get('fields.oib')
                    },
                    {
                        name: 'active',
                        width: '70px',
                        label: this.$LANG.Get('fields.activeF')
                    },
                    {
                        name: 'actions',
                        width: '50px',
                        label: ''
                    }
                ],
                filters: {
                    first_name: '',
                    last_name: '',
                    oib: '',
                    active: 1
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'first_name',
                    descending: false
                },
                filterTimer: null,
                height: '0px'
            },
            crossTabHandle: null
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/persons/' + id);
                window.open(routeData.href);
            } else {
                this.$router.push('/persons/' + id);
            }
        },
        addClick() {
            this.$router.push('/persons/0');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'persons', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.tableData.height = window.innerHeight - 205 + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-edit-new',
                html: this.$LANG.Get('help.editNewWindow'),
                left: -306,
                top: 0,
                width: 300
            },
            {
                class: 'help-edit',
                html: this.$LANG.Get('help.edit'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'persons');
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.persons'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-persons', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
</style>